const conversionDialogTranslations = {
  uploadTitle: 'Upload',
  convertTitle: 'Convert',
  downloadTitle: 'Download'
}

export default conversionDialogTranslations
